export default __webpack_public_path__ + "static/media/share.85ccf059.svg";